import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import {
  getData,
  postData,
} from "../../../CommonElements/Functions/PostGetFun";
import { API } from "../../../api/API";
import CommonTableNew from "../../Tables/ReactstrapTables/BasicTables/Common/CommonTableNew";
import {
  Modal,
  Button,
  Input,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux";
import { RootState } from "../../../redux-toolkit/store";
import {
  setVarifiedExpenses,
  addVarifiedExpense,
} from "../../../redux-toolkit/reducers/VarifiedExpensesReducer";
import CardHeaderSpan from "../../../Utils/CommonComponents/CardHeaderSpan";
import { Image } from "../../../AbstractElements";
import { dynamicImage } from "../../../Utils";

interface ExpenseMaster {
  ExpenseName: string;
  IsMandatory?: boolean;
}

interface ExpenseItem {
  ExpListId: number;
  ExpenseMaster: ExpenseMaster;
  ExpIlAmount: string;
  ExpFinalAmount: string;
  ExpNote: string;
  ExpRemark: string;
  ExpAuditRemark: string;
}

interface ExpenseDetails {
  data: ExpenseItem[];
  DayActivities?: Record<string, Record<string, string>>;
}

const ExpenseOverview: React.FC = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { expId, doVerify, expenseStatus } = location.state || {};
  const [expenseDetails, setExpenseDetails] = useState<ExpenseDetails | null>(
    null
  );

  const [openAmountModal, setOpenAmountModal] = useState(false);
  const [amount, setAmount] = useState("");
  const [addAmountNote, setAddAmountNote] = useState("");
  const [perticularLineItemData, setPerticularLineItemData] =
    useState<any>(null);

  const [openApprovedAmountModal, setOpenApprovedAmountModal] = useState(false);
  const [approvedAmount, setApprovedAmount] = useState("");
  const [note, setNote] = useState("");

  const [refresh, setRefresh] = useState(false);

  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [selectedExpListId, setSelectedExpListId] = useState<number | null>(
    null
  );

  const [expenseListDetails, setExpenseListDetails] = useState<any>(null);
  const [openDetailsModal, setOpenDetailsModal] = useState(false);

  const dispatch = useDispatch();
  const variedExpenses = useSelector(
    (state: RootState) => state.varifiedExpenses[expId] || []
  );
  console.log(variedExpenses, "variedExpenses");

  const triggerRefresh = () => setRefresh((prev) => !prev);

  useEffect(() => {
    const fetchExpenseDetails = async () => {
      try {
        const url = `${localStorage.getItem("serverUrl")}${
          API.getExpensesMaster
        }`;
        const params = { ExpId: expId };
        const { status, data } = await postData(url, true, params);

        if (status === 200) {
          setExpenseDetails(data?.data);
        } else {
          console.error("Failed to fetch expense details.");
        }
      } catch (error) {
        console.error("Error fetching expense details:", error);
      }
    };

    if (expId) {
      fetchExpenseDetails();
    }
  }, [expId, refresh]);

  const headData = [
    {
      id: "expenseName",
      head: "Expense Name",
      key: "ExpenseMaster.ExpenseName",
      sortKey: "ExpenseMaster.ExpenseName",
    },
    {
      id: "initialAmount",
      head: "Initial Amount",
      key: "ExpIlAmount",
      sortKey: "ExpIlAmount",
    },
    {
      id: "finalAmount",
      head: "Final Amount",
      key: "ExpFinalAmount",
      sortKey: "ExpFinalAmount",
    },
    { id: "note", head: "Note", key: "ExpNote", sortKey: "ExpNote" },
    { id: "remark", head: "Remark", key: "ExpRemark", sortKey: "ExpRemark" },
    {
      id: "auditRemark",
      head: "Audit Remark",
      key: "ExpAuditRemark",
      sortKey: "ExpAuditRemark",
    },
    { id: "actions", head: "Actions", key: "actions" },
  ];

  const getVarifiedExps = () => {
    const data = variedExpenses; // Use the existing selector outside of this function
    console.log(data, "=========variedExpenses=======");

    dispatch(setVarifiedExpenses({ expId, expenses: data }));
  };

  useEffect(() => {
    getVarifiedExps();
  }, []);

  const markVarified = (item: ExpenseItem) => {
    dispatch(
      addVarifiedExpense({ expId, expenseName: item.ExpenseMaster.ExpenseName })
    );
    triggerRefresh();
    navigate(-1); // Navigate back
  };

  const renderRow = (item: ExpenseItem, index: number) => {
    return (
      <tr key={index}>
        <td style={{ paddingLeft: "10px" }}>
          {item.ExpenseMaster.ExpenseName}
        </td>
        <td style={{ paddingLeft: "10px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{item.ExpIlAmount}</span>
            {/* <button
              style={{ marginLeft: '10px', background: 'none', border: 'none', cursor: 'pointer' }}
              onClick={() => openAddAmountModal(item)}
            >
              <i className="fa fa-edit" style={{ color: 'green', fontSize: '16px' }}></i>
            </button> */}
          </div>
        </td>
        <td style={{ paddingLeft: "10px" }}>
          <div style={{ display: "flex", alignItems: "center" }}>
            <span>{item.ExpFinalAmount}</span>
            {!(Number(expenseStatus) === 1 || Number(expenseStatus) === 2) && (
              <button
                style={{
                  marginLeft: "10px",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
                onClick={() => openAddApprovedAmountModal(item)}
              >
                <i
                  className="fa fa-edit"
                  style={{ color: "blue", fontSize: "16px" }}
                ></i>
              </button>
            )}
          </div>
        </td>
        <td style={{ paddingLeft: "10px" }}>{item.ExpNote || "-"}</td>
        <td style={{ paddingLeft: "10px" }}>{item.ExpRemark || "-"}</td>
        <td style={{ paddingLeft: "10px" }}>{item.ExpAuditRemark || "-"}</td>
        <td
          style={{ cursor: "pointer", paddingLeft: "10px" }}
          onClick={() => {
            console.log("Details clicked for", item.ExpListId);
            fetchExpenseListDetails(item.ExpListId);
          }}
        >
          <button
            style={{
              cursor: "pointer",
              padding: "5px 10px",
              backgroundColor: "#1c65d3",
              color: "white",
              border: "none",
              borderRadius: "5px",
            }}
            onClick={() => {
              console.log("Details clicked for", item.ExpListId);
              fetchExpenseListDetails(item.ExpListId);
              setOpenDetailsModal(true);
            }}
          >
            Details
          </button>
        </td>
        <td style={{ cursor: "pointer", paddingLeft: "10px" }}>
          {!(Number(expenseStatus) === 1 || Number(expenseStatus) === 2) && (
            <span
              onClick={() => {
                handleDeleteClick(item.ExpListId);
                console.log("Details clicked for", item.ExpListId);
              }}
            >
              <i
                className="fa fa-trash"
                style={{ color: "red", fontSize: "16px" }}
              ></i>
            </span>
          )}
        </td>
      </tr>
    );
  };

  const openAddAmountModal = (item: any) => {
    let isAttachmentRequired = item?.ExpenseMaster?.AttachmentRequired;
    setPerticularLineItemData(item);
    if (isAttachmentRequired && item?.ExpenseListDetailss?.length < 1) {
      toast.error(
        "Attachment is mandatory for this expense. Please go to details and add attachments."
      );
    } else {
      setAmount(item.ExpIlAmount?.toString() || ""); // Prefill previous amount here
      setAddAmountNote(item.ExpRemark || "");
      setOpenAmountModal(true);
    }
  };

  const handleSaveAmount = () => {
    const amt = amount === "" || amount == null ? "0" : amount;
    setAmount(amt); // Update state if needed
    // Call editLineItemAmount or any other function to save the amount
    console.log("Saved amount:", amt, "Note:", addAmountNote);
    setOpenAmountModal(false);
  };

  const openAddApprovedAmountModal = (item: any) => {
    setPerticularLineItemData(item);
    setOpenApprovedAmountModal(true);
    setApprovedAmount(item.ExpFinalAmount);
    setNote(item.ExpRemark || ""); // Prefill previous note
  };

  const editAndApproveLineItemAmount = async (lineItemData: any) => {
    try {
      const url = `${localStorage.getItem("serverUrl")}${
        API.editApprovalExpenses
      }/${lineItemData.ExpListId}`;
      const params = {
        action: "auth",
        ExpAprAmount: approvedAmount,
        exp_remark: note,
      };
      console.log("params==>> ", params, lineItemData.ExpListId);
      const { status, data } = await postData(url, true, params);

      if (status === 200) {
        toast.success(data.message);
        setOpenApprovedAmountModal(false);
        triggerRefresh();
      } else {
        toast.warning(data.message);
        setOpenApprovedAmountModal(false);
      }
    } catch (err) {
      console.error("Error:", err);
      toast.error("An error occurred while approving the amount.");
    }
  };

  const toggleDeleteModal = () => setIsDeleteModalOpen(!isDeleteModalOpen);

  const handleDeleteClick = (expListId: number) => {
    setSelectedExpListId(expListId);
    toggleDeleteModal();
  };

  const confirmDelete = async () => {
    if (!selectedExpListId) return;

    try {
      const url = `${localStorage.getItem("serverUrl")}${
        API.deleteExpenseList
      }`;
      const params = { exp_list_id: selectedExpListId };
      const { status, data } = await getData(url, true, params);

      console.log("Delete Response:", data);
      if (status === 200) {
        toast.success("Expense deleted successfully!");
        triggerRefresh();
      } else {
        toast.error("Failed to delete expense.");
      }
    } catch (error) {
      console.error("Error deleting expense:", error);
      toast.error("An error occurred while deleting the expense.");
    } finally {
      toggleDeleteModal();
    }
  };

  const makeNoteBold = (txt: string) => {
    let txt1 = txt.split("|");
    return [
      txt1[0],
      <strong>{txt1[1]}</strong>,
      <strong>{txt1[2]?.split(",")[0]}</strong>,
      txt1[2]?.split(",")[1],
      txt1[2]?.split(",")[2],
      <strong>{txt1[3]}</strong>,
      <strong>{txt1[4]}</strong>,
    ];
  };

  const [activityData, setActivityData] = useState<string[][]>([]);
  const [activityLabelName, setActivitylabelName] = useState<string[]>([]);

  useEffect(() => {
    try {
      const obj = expenseDetails?.DayActivities;
      console.log("Day Activities:", obj);

      if (obj) {
        const dayActivityData = Object.keys(obj)?.reduce<string[][]>(
          (arr, item) => {
            const values = Object.values(obj[item]) as string[];
            arr.push([item, ...values]);
            return arr;
          },
          []
        );
        setActivityData(dayActivityData);
        console.log("Activity Data:", dayActivityData);

        const patchName = Object.keys(obj)[0];
        const labelName = Object.keys(obj[patchName]);
        labelName.unshift("Patch");
        setActivitylabelName(labelName);
        console.log("Activity Label Name:", labelName);
      }
    } catch (error) {
      console.error("Error processing activity data:", error);
    }
  }, [expenseDetails]);

  const fetchExpenseListDetails = async (listId: number) => {
    try {
      const url = `${localStorage.getItem("serverUrl")}${
        API.getExpenseListDetails
      }`;
      const params = { exp_list_id: listId };
      const { status, data } = await getData(url, true, params);

      if (status === 200) {
        setExpenseListDetails(data.data);
        console.log("Fetched Expense List Details:", data.data);
      } else {
        console.error("Failed to fetch expense list details.");
      }
    } catch (error) {
      console.error("Error fetching expense list details:", error);
    }
  };

  if (
    !expenseDetails ||
    !expenseDetails.data ||
    expenseDetails.data.length === 0
  ) {
    return <p>Loading...</p>;
  }

  return (
    <div className="page-body p-3">
      <CardHeaderSpan
        headingClassName="p-2"
        back={true}
        heading={"Expense Overview"}
        span={"ReportListTitle"}
      />

      {expenseDetails ? (
        <CommonTableNew
          tableClass="table caption"
          strip={false}
          caption=""
          size="sm"
          hover
          headData={headData}
          data={expenseDetails.data}
          renderRow={renderRow}
        />
      ) : (
        <div className="text-center py-3">
          <div>
            <Image
              className="b-r-10 img-80"
              src={dynamicImage("dashboard/loader.gif")}
              alt="Loading..."
            />
          </div>
        </div>
      )}

      {/* {doVerify && <span
            style={{
            //  width: '130px',
              backgroundColor: variedExpenses?.includes(expenseDetails.data[0].ExpenseMaster.ExpenseName) ? 'green' : '#1c65d3',
              color: 'white',
              // border: variedExpenses?.includes(expenseDetails.data[0].ExpenseMaster.ExpenseName) ? 'none' : '2px solid green',
              padding: '5px 10px',
              cursor: 'pointer',
              borderRadius: '5px',
              marginTop: '5px',
            }}
            onClick={() => markVarified(expenseDetails.data[0])}
          >
            {variedExpenses?.includes(expenseDetails.data[0].ExpenseMaster.ExpenseName) ? 'Verified' : 'Mark Verified'}
          </span>} */}
      <Modal isOpen={openAmountModal} toggle={() => setOpenAmountModal(false)}>
        <div style={{ padding: "20px" }}>
          <h5>Requested Amount</h5>
          <Input
            type="number"
            placeholder="Enter Amount"
            value={amount}
            onChange={(e) => setAmount(e.target.value.replace(/[^0-9]/g, ""))}
          />
          <Input
            type="textarea"
            placeholder="Enter Note"
            value={addAmountNote}
            onChange={(e) => setAddAmountNote(e.target.value)}
            style={{ marginTop: "10px" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              marginTop: "20px",
            }}
          >
            <Button color="primary" onClick={handleSaveAmount}>
              Save
            </Button>
            <Button color="secondary" onClick={() => setOpenAmountModal(false)}>
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      <Modal
        isOpen={openApprovedAmountModal}
        toggle={() => setOpenApprovedAmountModal(false)}
      >
        <div style={{ padding: "20px" }}>
          <h5>Approved Amount</h5>
          <Input
            type="number"
            placeholder="Enter Approved Amount"
            value={approvedAmount}
            onChange={(e) =>
              setApprovedAmount(e.target.value.replace(/[^0-9]/g, ""))
            }
          />
          <Input
            type="textarea"
            placeholder="Enter Note"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            style={{ marginTop: "10px" }}
          />
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
              gap: "10px",
            }}
          >
            <Button
              color="primary"
              onClick={() =>
                editAndApproveLineItemAmount(perticularLineItemData)
              }
            >
              Submit
            </Button>
            <Button
              color="secondary"
              onClick={() => setOpenApprovedAmountModal(false)}
            >
              Cancel
            </Button>
          </div>
        </div>
      </Modal>
      <Modal isOpen={isDeleteModalOpen} toggle={toggleDeleteModal}>
        <ModalHeader toggle={toggleDeleteModal}>Confirm Deletion</ModalHeader>
        <ModalBody>Are you sure you want to delete this expense?</ModalBody>
        <ModalFooter>
          <Button color="danger" onClick={confirmDelete}>
            Delete
          </Button>{" "}
          <Button color="secondary" onClick={toggleDeleteModal}>
            Cancel
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        isOpen={openDetailsModal}
        toggle={() => setOpenDetailsModal(false)}
      >
        <div style={{ padding: "20px" }}>
          <h5>Expense Details</h5>
          {expenseListDetails && expenseListDetails.length > 0 && (
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Image
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Remark
                  </th>
                  <th style={{ border: "1px solid #ddd", padding: "8px" }}>
                    Rupees
                  </th>
                </tr>
              </thead>
              <tbody>
                {expenseListDetails.map((detail: any, index: number) => (
                  <tr key={index}>
                    <td
                      style={{
                        border: "1px solid #ddd",
                        padding: "8px",
                        textAlign: "center",
                      }}
                    >
                      <a
                        href={`${localStorage.getItem("serverUrl")}media?id=${
                          detail.Image
                        }`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          src={`${localStorage.getItem("serverUrl")}media?id=${
                            detail.Image
                          }`}
                          alt="Expense Image"
                          style={{ width: "100px", borderRadius: "5px" }}
                        />
                      </a>
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      {detail.Description || "-"}
                    </td>
                    <td style={{ border: "1px solid #ddd", padding: "8px" }}>
                      <p> {detail.Amount}</p>
                      {/* <p><strong>Created At:</strong> {detail.CreatedAt}</p>
                      <p><strong>Updated At:</strong> {detail.UpdatedAt}</p> */}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              marginTop: "20px",
            }}
          >
            <Button
              color="secondary"
              onClick={() => setOpenDetailsModal(false)}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>

      {/* Render Activity Data Table */}
      {activityData.length > 0 && activityLabelName.length > 0 && (
        <div style={{ marginTop: "20px" }}>
          <h3>Activity Data</h3>
          <CommonTableNew
            tableClass="table caption"
            strip={false}
            caption=""
            size="sm"
            hover
            headData={activityLabelName.map((label, index) => ({
              id: `col-${index}`,
              head: label,
              key: label,
            }))}
            data={activityData.map((row) => {
              const rowData: Record<string, string | number> = {};
              activityLabelName.forEach((label, index) => {
                rowData[label] = row[index] || "-";
              });
              return rowData;
            })}
            renderRow={(row, index) => (
              <tr key={index}>
                {activityLabelName.map((label, colIndex) => (
                  <td style={{ paddingLeft: "10px" }} key={colIndex}>
                    {row[label]}
                  </td>
                ))}
              </tr>
            )}
          />
        </div>
      )}
    </div>
  );
};

export default ExpenseOverview;
